import { render, staticRenderFns } from "./AppBoard.vue?vue&type=template&id=b83aeba8&scoped=true&"
import script from "./AppBoard.vue?vue&type=script&lang=js&"
export * from "./AppBoard.vue?vue&type=script&lang=js&"
import style0 from "./AppBoard.vue?vue&type=style&index=0&id=b83aeba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83aeba8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppAside: require('/opt/build/repo/components/AppAside.vue').default,SlideView: require('/opt/build/repo/components/SlideView.vue').default})
